module.exports = new __parcel__URL__("toy-story.7d4d421e.jpg").toString();